import React from "react";

import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Slide from "@mui/material/Slide";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const NewFeatureDialog = ({onClose, contentEl}) => {

    const [remindMeLater, toggleRemindMeLater] = React.useReducer((state) => !state, false);

    return <Dialog open={true}
                   onClose={onClose}
                   aria-labelledby="alert-dialog-title"
                   aria-describedby="alert-dialog-description"
                   fullWidth
                   TransitionComponent={Transition}>

        <DialogTitle id="alert-dialog-title">
            Nuove funzionalità
        </DialogTitle>

        <DialogContent>
            <Stack spacing={4}>
                {contentEl}
            </Stack>
        </DialogContent>

        <DialogActions sx={{p: 2, justifyContent: "space-between"}}>
            <FormControlLabel control={<Checkbox checked={remindMeLater} onChange={toggleRemindMeLater} />}
                              label={<Typography color="text.primary">Ricordamelo dopo</Typography>}/>
            <Button color="primary"
                    variant="contained"
                    onClick={() => onClose(remindMeLater)}>
                Ok
            </Button>
        </DialogActions>
    </Dialog>
}

export default NewFeatureDialog;